import React from 'react';
import { Link } from 'react-router-dom';
import { usePortalAuth } from '../../context/PortalAuth';
import { orgName } from '../../context/PortalOrg';
import { ROLE_LABELS } from '../../lib/portalPermissions';
import { Button } from '../../components/ui/Button';
import { PageHeader } from '../../components/portal/PageHeader';
import { Avatar } from '../../components/portal/Avatar';
import { ProductTag } from '../../components/portal/ProductTag';
import { displayName, formatDateTime } from '../../utils/portalFormat';

/** The person's own record and every organisation they can reach. */
export function PortalAccount() {
  const {
    user,
    memberships,
    signOut
  } = usePortalAuth();
  if (!user) return null;
  return <div data-id="element-2814" data-mp="3vwc0rnwy48kp">
      <PageHeader title="Account" description="Your details, and the organisations you can work in." data-id="element-2815" data-mp="3vwkefi0w7hwy" />

      <section aria-labelledby="profile" className="mt-8 flex flex-col gap-6 sm:flex-row sm:items-center" data-id="element-2816" data-mp="dqfq35jrbd3q">
        <Avatar user={user} data-id="element-2817" data-mp="8s4kj70hvorb" />
        <div data-id="element-2818" data-mp="8oqiy0znnjkx">
          <h2 id="profile" className="text-[18px] text-ink" data-id="element-2819" data-mp="5a9myw5gcxud">
            {displayName(user)}
          </h2>
          <p className="text-[14px] text-muted" data-id="element-2820" data-mp="a8ku2z4d4u8w">
            {user.jobTitle}, {user.email}
          </p>
          {user.lastLoginAt && <p className="mt-1 text-[13px] text-muted" data-id="element-2821" data-mp="f7eaazb1azcr">Last signed in {formatDateTime(user.lastLoginAt)}</p>}
        </div>
      </section>

      <section aria-labelledby="orgs" className="mt-12" data-id="element-2822" data-mp="j7ofi9r05lqk">
        <h2 id="orgs" className="font-display text-[20px] text-ink" data-id="element-2823" data-mp="o7uds8rs26hm">
          Organisations
        </h2>
        <ul className="mt-4 divide-y divide-line border-y border-line" data-id="element-2824" data-mp="t6nq3xvbvrg7">
          {memberships.map(m => <li key={m.orgId} className="flex flex-col gap-2 py-4 sm:flex-row sm:items-center sm:justify-between" data-id="element-2825" data-mp="xz72iria4gjf">
              <div data-id="element-2826" data-mp="12zurz8qv0pbj">
                <Link to={`/portal/orgs/${m.orgId}/projects`} className="text-[15px] text-ink hover:text-royal" data-id="element-2827" data-mp="16zdeua28rah0">
                  {orgName(m.orgId)}
                </Link>
                <div className="mt-1 flex flex-wrap gap-x-4 gap-y-1" data-id="element-2828" data-mp="1byq22vx0yjk4">
                  {m.productIds.map(id => <ProductTag key={id} productId={id} data-id="element-2829" data-mp="37z8lkatc0ibe" />)}
                </div>
              </div>
              <span className="self-start rounded-full border border-line px-2.5 py-0.5 text-[12px] text-body sm:self-auto" data-id="element-2830" data-mp="3hr4k1mzbyag5">{ROLE_LABELS[m.role]}</span>
            </li>)}
        </ul>
      </section>

      <section aria-labelledby="security" className="mt-12 max-w-2xl" data-id="element-2831" data-mp="3rp2eis7s93h7">
        <h2 id="security" className="font-display text-[20px] text-ink" data-id="element-2832" data-mp="3rretcwi8uxq1">
          Signing in
        </h2>
        <p className="mt-3 text-[15px] leading-relaxed text-body" data-id="element-2833" data-mp="4kvyj6f5nr0w">
          You sign in with a link sent to {user.email}. There is no password to store or leak. Each link works once and
          expires after 15 minutes, and your session renews quietly while you are active for up to 30 days.
        </p>
        <p className="mt-3 text-[15px] leading-relaxed text-body" data-id="element-2834" data-mp="21decu7cwz62a">
          To change your name, email or job title, message the team and we will update it.
        </p>
        <Button variant="secondary" className="mt-6" onClick={() => void signOut()} data-id="element-2835" data-mp="gx6r3juwibfc">
          Sign out on this device
        </Button>
      </section>
    </div>;
}